import React, { useState, useEffect } from 'react';
import { Grid, GridColumn as Column, GridPageChangeEvent } from '@progress/kendo-react-grid';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from '../../../utils/api';
import { RootState } from '../../../store/store';
import BagelLapsWorkoutDetailComponent from './BagelLapsWorkoutDetailComponent';
import { genderMap } from 'store/types/GenderCode';
import { Patient } from '@types';
//import './BagelLapsPatientDetailComponent.css';

interface BagelLapsPatientDetail {
  ptCd: string;
}

interface BagelLapsWorkoutRecord {
  id: number;
  createdAt: string;
}

interface SelectedRecord {
  ptCd: string;
  id: number;
  createdAt: string;
}

const BagelLapsPatientDetailComponent: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const user = useSelector((state: RootState) => state.user.user);

  const [patient, setPatient] = useState<BagelLapsPatientDetail | null>(null);
  const [workoutRecords, setWorkoutRecords] = useState<BagelLapsWorkoutRecord[]>([]);
  const [page, setPage] = useState({ skip: 0, take: 10 });
  const [selectedRecord, setSelectedRecord] = useState<SelectedRecord | null>(null);
  const [showRecordDetail, setShowRecordDetail] = useState(false);

  useEffect(() => {
    const fetchPatientDetail = async () => {
      if (user?.hospital?.hspCd && id) {
        try {
          const response = await api.getBagelLapsPatientDetailAsync(id, user.hospital.hspCd);
          setPatient(response.data);
          setWorkoutRecords(response.data.patientWorkoutInfo);
        } catch (error) {
          console.error('환자 상세 정보를 가져오는 중 오류 발생:', error);
        }
      }
    };

    fetchPatientDetail();
  }, [id, user]);

  const onPageChange = (e: GridPageChangeEvent) => {
    setPage(e.page);
  };

  const handleRecordDetail = (record: BagelLapsWorkoutRecord) => {
    if (!patient?.ptCd) return;

    setSelectedRecord({
      ptCd: patient.ptCd,
      id: record.id,
      createdAt: record.createdAt,
    });

    setShowRecordDetail(true);
  };

  const closeRecordDetail = () => {
    setSelectedRecord(null);
    setShowRecordDetail(false);
  };

  const GenderCell = (props: any) => {
    const gender = props.dataItem.gender;
    return <td>{genderMap[gender] || gender}</td>;
  };

  return (
    <div className="layoutContainer PatientDetailPage">
      <h2>환자 상세 정보</h2>
      {patient && (
        <div className="PatientDetail">
          <div className="PatientInfoGrid">
            <Grid data={[patient]}>
              <Column field="ptCd" title="환자코드" width="120px" />
              <Column field="name" title="이름" width="150px" />
              <Column field="gender" title="성별" width="80px" cell={GenderCell} />
              <Column field="birthDate" title="생년월일" width="120px" />
              <Column field="phoneNumber" title="전화번호" width="150px" />
            </Grid>
          </div>

          <div className="PatientHealthGrid">
            <h3>운동 기록</h3>
            <Grid
              data={workoutRecords.slice(page.skip, page.skip + page.take)}
              pageable
              skip={page.skip}
              take={page.take}
              total={workoutRecords.length}
              onPageChange={onPageChange}
            >
              <Column field="createdAt" title="운동 날짜" />
              <Column
                field="recordDetail"
                title="기록 상세"
                cell={(props) => (
                  <td>
                    <button
                      className="MainBtncolor openBtn"
                      onClick={() => handleRecordDetail(props.dataItem)}
                    >
                      상세 보기
                    </button>
                  </td>
                )}
              />
            </Grid>

            {selectedRecord && (
              <div className="record-detail-modal">
                <button className="MainBtncolor closebutton" onClick={closeRecordDetail}>
                  닫기
                </button>
                <BagelLapsWorkoutDetailComponent
                  ptCd={selectedRecord.ptCd}
                  id={selectedRecord.id}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BagelLapsPatientDetailComponent;
